var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qrcode-card-c" }, [
    _c("img", {
      staticClass: "code-img",
      attrs: { src: _vm.qrimageUrl, alt: "" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "desc-c" }, [
      _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _vm.price
        ? _c("div", { staticClass: "price" }, [_vm._v(_vm._s(_vm.price))])
        : _vm._e(),
      _vm._v(" "),
      _vm.tagName
        ? _c("span", { staticClass: "tag" }, [_vm._v(_vm._s(_vm.tagName))])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { clear: "both" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }